export default "__VITE_ASSET__BpUOXmON__"